module.exports = __webpack_public_path__ + "img/kek.ffe89f10.png";